"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.DarksideMeteorBombardment = void 0;
var CardName_1 = require("../../CardName");
var CardType_1 = require("../CardType");
var Tags_1 = require("../Tags");
var MoonExpansion_1 = require("../../moon/MoonExpansion");
var CardRenderer_1 = require("../render/CardRenderer");
var Card_1 = require("../Card");
var DarksideMeteorBombardment = (function (_super) {
    __extends(DarksideMeteorBombardment, _super);
    function DarksideMeteorBombardment() {
        return _super.call(this, {
            name: CardName_1.CardName.DARKSIDE_METEOR_BOMBARDMENT,
            cardType: CardType_1.CardType.EVENT,
            tags: [Tags_1.Tags.SPACE],
            cost: 20,
            metadata: {
                description: 'Gain 2 steel and 2 titanium. Raise the Mining Rate 2 steps.',
                cardNumber: 'M33',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.steel(2).titanium(2);
                    b.br;
                    b.moonMiningRate({ amount: 2 });
                }),
            },
        }) || this;
    }
    ;
    DarksideMeteorBombardment.prototype.play = function (player) {
        player.steel += 2;
        player.titanium += 2;
        MoonExpansion_1.MoonExpansion.raiseMiningRate(player, 2);
        return undefined;
    };
    return DarksideMeteorBombardment;
}(Card_1.Card));
exports.DarksideMeteorBombardment = DarksideMeteorBombardment;
//# sourceMappingURL=DarksideMeteorBombardment.js.map